<template>
  <span class="number">{{ currentNumber }}</span>
</template>

<script>
import utils from '@/utils/utils.js'
export default {
  name: 'numberCount',
  props: {
    targetNumber: {
      type: Number,
      default: 0
    },
    floor: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      currentNumber: 0, // 当前显示的数值
      duration: 1000 // 动画持续时间（毫秒）
    }
  },
  watch: {
    targetNumber: {
      handler(newValue) {
        this.startAnimation()
      },
      immediate: true
    }
  },
  methods: {
    startAnimation() {
      const start = 0 // 起始数值
      const end = this.targetNumber // 目标数值
      const duration = this.duration // 动画时长
      const startTime = performance.now()

      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime // 已经过去的时间
        const progress = Math.min(elapsedTime / duration, 1) // 动画进度 (0 到 1)

        this.currentNumber = utils.priceFormat(
          start + progress * (end - start),
          this.floor
        )

        if (progress < 1) {
          requestAnimationFrame(animate)
        }
      }

      requestAnimationFrame(animate)
    }
  }
}
</script>

<style></style>
